import { Brand } from "@/types/brand";
import { BrandInformationForm } from "@/components/forms/BrandInformationForm";

interface BrandInformationStepProps {
  data: Brand;
  onNext: (data: Partial<Brand>) => void;
}

export function BrandInformationStep({
  data,
  onNext,
}: BrandInformationStepProps) {
  return (
    <BrandInformationForm data={data} onSubmit={onNext} mode="onboarding" />
  );
}
